import { render, staticRenderFns } from "./MasterCustomerApprove.vue?vue&type=template&id=f33b16c0&scoped=true&"
import script from "./MasterCustomerApprove.vue?vue&type=script&lang=js&"
export * from "./MasterCustomerApprove.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=f33b16c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33b16c0",
  null
  
)

export default component.exports